(function(EF) {

  var ActionPlanItemResponse = Chaplin.Model.extend({
    initialize: function(attributes, options) {
      this.enrollment = options.enrollment || (this.collection ? this.collection.enrollment : null);
    },

    url: function() {
      var suffix = this.get('id') ? this.get('id') + '.json' : '';
      return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/action_plan_item_responses/' + suffix);
    },

    toJSON: function() {
      return { action_plan_item_response: _.clone(this.attributes) };
    }
  });

  _.extend(EF.Models, {
    ActionPlanItemResponse: ActionPlanItemResponse
  });

}(EF));
